import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-videos',
  templateUrl: './help-videos.component.html',
  styleUrls: ['./help-videos.component.scss']
})
export class HelpVideosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
